import { RecentlyCreatedReportRow } from '@tap/data-providers';
import { PeriodSelectType, PeriodSelectTypeSpec, Widget } from '@tap/mui-ui';
import { ChartCustom, CustomChartTooltip } from '@tap/tap-ui';
import { dateTimeHelper } from '@tap/utils';
import {
    XAxis, YAxis, CartesianGrid,
    Tooltip as RechartsTooltip, Bar, BarChart,
} from 'recharts';

/* График Недавно созданные заявки
*/

type RecentlyCreatedIssuesChartProps = {
    reportData: RecentlyCreatedReportRow[],
    periodType: PeriodSelectType,
}

const getMaxValue = (initialData: RecentlyCreatedReportRow[]) => {
    const totalCount = initialData.map(r => r.totalCount);
    return Math.max(...totalCount);
}


export const RecentlyCreatedIssuesChart = ({ reportData, periodType }: RecentlyCreatedIssuesChartProps) => {

    const maxValue = getMaxValue(reportData);

    return (
        <Widget title={`График показывает заявки, созданные за последние ${PeriodSelectTypeSpec[periodType].daysQuantity} дней`}>
            <ChartCustom>
                <BarChart data={reportData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        type="category"
                        dataKey="date"
                        scale="auto"
                        tick={{ dy: 5, fontSize: '12px' }}
                        tickFormatter={(date: any) => dateTimeHelper.format(date, 'd MMM', true) || date}
                    />
                    <YAxis
                        dataKey='incompletedCount'
                        domain={[0, maxValue]}
                        tick={{ fontSize: '12px' }}
                    />
                    <RechartsTooltip
                        wrapperStyle={{ outline: 'none' }}
                        content={
                            <CustomChartTooltip
                                labelTemplate={(label) => {
                                    return dateTimeHelper.format(label, 'd MMMM yyyy');
                                }}
                                valueTemplate={payload =>
                                    <>{payload.name}: {payload.value} из {payload.payload.totalCount}</>
                                }
                            />
                        }
                    />
                    <Bar
                        opacity={.8}
                        name={'Не завершено'}
                        dataKey="incompletedCount"
                        stroke={'rgb(255, 128, 66)'}
                        fill={'rgb(255, 128, 66)'}
                        stackId="a"
                    />
                    <Bar
                        opacity={.8}
                        name={'Завершено'}
                        dataKey="completedCount"
                        stroke={'rgb(0, 196, 159)'}
                        fill={'rgb(0, 196, 159)'}
                        stackId="a"
                    />
                </BarChart>
            </ChartCustom>
        </Widget>
    );
}

